import { useEffect } from "react";

import useFetchProviderDetails from "../../hooks/useFetchProviderDetails";
import useModifyProviderDetails from "../../hooks/useModifyProviderDetails";
import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";
import LoadingIndicator from "../fields/LoadingIndicator";
import ProviderDetailEditModal from "../modal/ProviderDetailEditModal";

import ProviderAdditionalEmailsDisplayView from "./ProviderAdditionalEmailsDisplayView";
import ProviderAdditionalPhonesDisplayView from "./ProviderAdditionalPhonesDisplayView";
import ProviderContact from "./ProviderContact";
import ProviderHeader from "./ProviderHeader";
import ProviderSummary from "./ProviderSummary";

export default function ProviderDetail() {
  const { fetchProviderDetails } = useFetchProviderDetails();
  const { data, loading, openModal, setOpenModal } = useProviderDetailStore();
  const { handleOnClickCancelButton } = useModifyProviderDetails();

  useEffect(() => {
    setOpenModal(false);
    fetchProviderDetails();
  }, [fetchProviderDetails]);

  return (
    <div className="flex h-full w-full flex-col gap-4 p-4">
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          <ProviderHeader data={data} />
          <div className="flex h-full w-full flex-col gap-2 overflow-y-auto [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
            <ProviderContact data={data} />
            <ProviderAdditionalEmailsDisplayView data={data} />
            <ProviderAdditionalPhonesDisplayView data={data} />
            <ProviderSummary data={data} />
          </div>
          <ProviderDetailEditModal
            openModal={openModal}
            handleCloseModal={handleOnClickCancelButton}
          />
        </>
      )}
    </div>
  );
}
